import { Injectable } from '@angular/core';
import { selectSubSiteId } from '@epicuro-next/state/session-state';
import * as uiStateActions from '@epicuro-next/state/user-ui-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import * as productBasketActions from '../product-basket.actions';

import {
  selectPresetDisplayName,
  selectPresetValue,
} from './../product-basket.selectors';

/**
 * Product Basket Effects
 */
@Injectable()
export class UiStateEffects {
  /*
   * Effects to trigger a product load after a filter load is performed
   */
  public toggleWaitingNewOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uiStateActions.toggleWaitingNewOrder),
      map((action) => action.waitingNewOrder),
      filter(Boolean),
      switchMap(() => [
        productBasketActions.resetFilters(),
        uiStateActions.toggleWaitingNewOrder({ waitingNewOrder: false }),
      ]),
    ),
  );

  public resetSubSiteId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uiStateActions.toggleWaitingNewOrder),
      map((action) => action.waitingNewOrder),
      filter((waitingNewOrder) => !waitingNewOrder),
      concatLatestFrom(() => [this.store.pipe(select(selectSubSiteId))]),
      filter(([, subsites]) => !!subsites),
      map(([, subsites]) => subsites),
      map((subsites: string) => {
        return productBasketActions.setSubsites({ subsites });
      }),
    ),
  );

  public setPresetFilterOnChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        productBasketActions.setRuleEnginePresetValue,
        productBasketActions.toggleFilter,
      ),
      withLatestFrom(
        this.store.pipe(select(selectPresetDisplayName)),
        this.store.pipe(select(selectPresetValue)),
      ),
      map(([_, displayName, presetValue]) => displayName ?? presetValue),
      filter((v): v is string => isNonNullish(v)),
      map((presetFilter) => uiStateActions.updatePresetValue({ presetFilter })),
    ),
  );

  constructor(private actions$: Actions, private store: Store) {}
}
